<template>
  <!-- <div v-bind:class="{ showHeaderWhite: isFixed }" class="landing-header">
    <b-navbar
      fixed="top"
      toggleable="xl"
      class="navbar-inverse"
      v-bind:class="{ activeHeader: scrolled }"
    >
      <b-container fluid="xl">
        <router-link to="/">
          <b-navbar-brand class="header-logo logo-white">
            <img
              src="/assets/images/banner/kips-logo.svg"
              alt="KIPS Virtual"
              width="66"
              height="50"
            />
          </b-navbar-brand>

          <b-navbar-brand class="header-logo logo-blue">
            <img
              class="logo-blue"
              src="/assets/images/banner/Logo.png"
              width="52"
              height="50"
            />
          </b-navbar-brand>
        </router-link>
        <router-link
          v-if="specialCourses.length > 0"
          class="no-decor fmcat"
          to="/activities"
        >
          <span class="special-logo">
            <img
              src="/assets/images/banner/special-logo.png"
              alt=""
              width="19"
              height="20"
            />
            <span>Activities</span>
          </span>
        </router-link>

        <div
          class="top-header-cart small-show"
          :class="specialCourses.length > 0 ? '' : 'ml-auto'"
        >
          <router-link v-if="$route.name !== 'registration'" class="no-decor" to="/cart">
            <span>
              <i class="fal fa-shopping-cart"></i>
              <span class="count">{{ this.totalRecordInCart }}</span>
            </span>
          </router-link>
        </div>
        <div class="menu-toggle-btn" v-bind:class="{ open: isOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <b-navbar-toggle target="nav-collapse" @click="openMenu"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="ml-auto" v-model="visible">
          <b-navbar-nav @click="startScroll" class="">
            <li @click="openMenu" class="special-logo" v-if="specialCourses.length > 0">
              <img
                src="/assets/images/banner/special-logo.png"
                alt=""
                width="19"
                height="20"
              />
              <router-link class="nav-link pl-2 pl-xl-0" to="/activities"
                >Activities</router-link
              >
            </li>
            <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/popularPrograms"
                >Featured Programs</router-link
              >
            </li>
          </b-navbar-nav>

          <div class="top-header-cart large-show mr-2">
            <router-link
              v-if="$route.name !== 'registration'"
              class="no-decor"
              to="/cart"
            >
              <span>
                <i class="fal fa-shopping-cart"></i>
                <span class="count">{{ this.totalRecordInCart }}</span>
              </span>
            </router-link>
          </div>
          <div class="top-header-btn">
            <router-link class="header-enroll-btn mr-2" to="/category">
              Enroll
            </router-link>
            <a class="header-login-btn" :href="gotoPortal()">
              <template>Portal</template>
</a>
</div>
</b-collapse>
</b-container>
</b-navbar>
</div> -->

  <header class="site-header">
    <div class="upperheader">
      <div class="container">
        <div class="topnav">
          <div class="logo">
            <router-link to="/"> <img src="/assets/images/os-images/os-header-logo.png" alt="Logo" width="148" height="64" /></router-link>
          </div>
          <div class="upper-right">
            <ul class="d-none d-lg-block">
              <li><button @click="showVideoPopup()">Introductory Video</button></li>
              <li><button @click="openExpertAdvicePopup()">Ask a Question</button></li>
              <li><button @click="openBookDemoPopup()">Book a Demo</button></li>
            </ul>
            <div class="search-part">
              <!-- <div class="notification-wrapper">
                <div class="bell-icon" id="bell-icon">
                  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.25027 13.5977C9.25027 14.1944 9.01322 14.7667 8.59126 15.1887C8.16931 15.6106 7.59701 15.8477 7.00027 15.8477C6.40353 15.8477 5.83124 15.6106 5.40928 15.1887C4.98732 14.7667 4.75027 14.1944 4.75027 13.5977M7.54102 3.09992L6.44152 3.09767C3.93352 3.09167 1.75627 5.12942 1.73902 7.59767V10.4402C1.73902 11.0327 1.66402 11.6109 1.34077 12.1037L1.12552 12.4322C0.797765 12.9302 1.15027 13.5977 1.73902 13.5977H12.2615C12.8503 13.5977 13.202 12.9302 12.875 12.4322L12.6598 12.1037C12.3373 11.6109 12.2615 11.0319 12.2615 10.4394V7.59842C12.2315 5.12942 10.049 3.10592 7.54102 3.09992V3.09992Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7 1C7.39783 1 7.77936 1.15804 8.06066 1.43934C8.34197 1.72065 8.5 2.10218 8.5 2.5V3.25H5.5V2.5C5.5 2.10218 5.65804 1.72065 5.93934 1.43934C6.22065 1.15804 6.60218 1 7 1Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <div class="notification-popup" id="notification-popup">
                  <div class="notificationContainer">
                    <h3>Notifications</h3>
                    <div class="notificationData">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi sit facilis fuga blanditiis ad ipsa. Quidem voluptas magnam dicta quis eum temporibus amet dolorem repudiandae hic, placeat quisquam excepturi sequi.</div>
                  </div>
                </div>
              </div> -->
              <div class="cta">
                <router-link to="/portals" class="purple-btn">Portals</router-link>
              </div>
            </div>
            <div id="menu" class="toggle-btn">
              <span class="bar bar-1"></span>
              <span class="bar bar-2"></span>
              <span class="bar bar-3"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerheader">
      <div class="container">
        <ul class="d-lg-none smalllower">
          <li><button @click="showVideoPopup()">Introductory Video</button></li>
          <li><button @click="openExpertAdvicePopup()">Ask a Question</button></li>
          <li><button @click="openBookDemoPopup()">Book a Demo</button></li>
        </ul>
        <div class="botnav">
          <div class="primary-menu-container">
            <ul class="menu-wrapper">
              <li class="menuLink" @mouseenter="onMouseEnter('home')" @mouseleave="onMouseLeave">
                <router-link to="/">Home</router-link>
                <ul class="sub-menu" :class="{ 'show-submenu': activeMenu === 'home' }">
                  <!-- <router-link class="footer-links" to="/#our-focus">Enroll</router-link> -->
                  <li><router-link to="/#our-focus">Our Focus</router-link></li>
                  <li><router-link to="/#kips-grades">KIPS Grades</router-link></li>
                  <li>
                    <router-link to="/#school-activity">School Activities</router-link>
                  </li>
                  <li><router-link to="/#hearaboutus">Hear About Us</router-link></li>
                  <li><router-link to="/#key-features">Key Features</router-link></li>
                  <li>
                    <router-link to="/#featured-programs">Featured Programs</router-link>
                  </li>
                  <li>
                    <router-link to="/#student-supports">Support System</router-link>
                  </li>
                </ul>
              </li>
              <li @mouseenter="onMouseEnter('about')" @mouseleave="onMouseLeave">
                <router-link to="/about">About Us</router-link>
                <!-- <a href="#">About Us</a> -->
                <ul class="sub-menu" :class="{ 'show-submenu': activeMenu === 'about' }">
                  <li><router-link to="/about#our-history">Our History</router-link></li>
                  <!-- <li><router-link to="/about#">BODs</router-link></li> -->
                  <li>
                    <router-link to="/about#msg-from-ceo">Message from CE</router-link>
                  </li>
                  <li>
                    <router-link to="/about#what-we-offer">What We Offer?</router-link>
                  </li>
                </ul>
              </li>
              <li class="megamenu" @mouseenter="onMouseEnter('school')" @mouseleave="onMouseLeave">
                <a href="#">Our School</a>
                <div class="sub-menu" :class="{ 'show-submenu': activeMenu === 'school' }">
                  <div class="lilstWrapper">
                    <div class="listCol">
                      <div class="listBlock">
                        <strong class="d-block">Early Years</strong>
                        <ul>
                          <li class="not-available"><a href="#">Playgroup</a></li>
                          <li class="not-available"><a href="#">Nursery</a></li>
                          <li class="not-available"><a href="#">Prep</a></li>
                        </ul>
                      </div>
                    </div>

                    <div class="listCol">
                      <div class="listBlock">
                        <strong class="d-block">Junior School</strong>
                        <ul>
                          <!-- <li>
                            <router-link :to="`/detail/junior-school/${generateEncryptedId(8)}/program#grade-1`">Grade 1</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/junior-school/${generateEncryptedId(8)}/program#grade-2`">Grade 2</router-link>
                          </li> -->
                          <li>
                            <router-link :to="`/detail/junior-school/${generateEncryptedId(8)}/program#grade-3`">Grade 3</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/junior-school/${generateEncryptedId(8)}/program#grade-4`">Grade 4</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/junior-school/${generateEncryptedId(8)}/program#grade-5`">Grade 5</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="listCol">
                      <div class="listBlock">
                        <strong class="d-block">Lower Secondary </strong>
                        <ul>
                          <li>
                            <router-link :to="`/detail/lower-secondary-school/${generateEncryptedId(9)}/program#grade-6`">Grade 6</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/lower-secondary-school/${generateEncryptedId(9)}/program#grade-7`">Grade 7</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/lower-secondary-school/${generateEncryptedId(9)}/program#grade-8`">Grade 8</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="listCol">
                      <div class="listBlock">
                        <strong class="d-block">Secondary School</strong>
                        <ul>
                          <!-- <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(2)}/group#grade-pre-9`">Grade Pre-9</router-link>
                          </li> -->
                          <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(10)}/group#grade-9`">Grade 9</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(10)}/group#grade-10`">Grade 10</router-link>
                          </li>
                          <li class="not-available">
                            <router-link to="#">0-level-O1</router-link>
                          </li>
                          <li class="not-available">
                            <router-link to="#">0-level-O2</router-link>
                          </li>
                          <li class="not-available">
                            <router-link to="#">0-level-O3</router-link>
                          </li>
                          <!-- <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(10)}/group#0-level-O1`">0-level-O1</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(10)}/group#0-level-O2`">0-level-O2</router-link>
                          </li>
                          <li>
                            <router-link :to="`/detail/secondary-school/${generateEncryptedId(10)}/group#0-level-O3`">0-level-O3</router-link>
                          </li> -->
                        </ul>
                      </div>
                    </div>

                    <div class="listCol">
                      <div class="listBlock">
                        <strong class="d-block">Higher Secondary </strong>
                        <ul>
                          <li class="not-available"><a href="#">Grade 11</a></li>
                          <li class="not-available"><a href="#">Grade 12</a></li>
                        </ul>
                      </div>
                    </div>

                    <div class="listCol">
                      <!-- <div class="listBlock">
                        <strong class="d-block">Early Years</strong>
                        <ul>
                          <li><a href="#">Our History</a></li>
                          <li><a href="#">BODs</a></li>
                          <li><a href="#">Msg from CEO</a></li>
                          <li><a href="#">What we offer?</a></li>
                        </ul>
                      </div> -->
                      <div class="listBlock">
                        <strong class="d-block">Enrichment Programs</strong>
                        <ul>
                          <li class="not-available">
                            <a href="#">Digital Literacy Program</a>
                          </li>
                          <li class="not-available">
                            <a href="#">Foreign Language Program (Arabic)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">Mathematics Base Strengthening (III-VIII)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">English Language Program(I-VIII)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">Computer Certification Program (I-VIII)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">Physical and mental well being (Whole Program)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">ilead (leadership Program)</a>
                          </li>
                          <li class="not-available">
                            <a href="#">Art and Craft (Whole School Program)</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li @mouseenter="onMouseEnter('registration')" @mouseleave="onMouseLeave">
                <router-link to="/registration">Registration</router-link>
                <ul class="sub-menu" :class="{ 'show-submenu': activeMenu === 'registration' }">
                  <!-- <li><router-link to="/about#our-history">Our History</router-link></li> -->
                  <li>
                    <router-link :to="{ path: '/registration', hash: '#enrollments' }">Enrollment Process</router-link>
                  </li>
                  <li>
                    <router-link :to="{ path: '/registration', hash: '#admission-schedules' }">Admissions Schedule</router-link>
                  </li>
                  <li>
                    <router-link :to="{ path: '/registration', hash: '#faq' }">FAQs</router-link>
                  </li>
                  <!-- <li>
                    <router-link
                      :to="{ path: '/registration', hash: '#admission-policies' }"
                      >Admission Policy</router-link
                    >
                  </li> -->
                  <li>
                    <router-link :to="{ path: '/registration', hash: '#enroll' }">Enroll</router-link>
                  </li>
                </ul>
              </li>
              <li @mouseenter="onMouseEnter('activities')" @mouseleave="onMouseLeave">
                <router-link to="/activities">Activities</router-link>
                <ul class="sub-menu" :class="{ 'show-submenu': activeMenu === 'activities' }">
                  <li>
                    <router-link :to="{ path: '/activities', hash: '#cocurricular' }">Co-Curricular Activities</router-link>
                  </li>
                  <li class="not-available">
                    <router-link to="#">Competitions</router-link>
                  </li>
                  <li class="not-available">
                    <router-link to="#">Activity Gallery</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="lg" centered id="introductoryVideoModal" title="" hide-footer hide-header content-class="p-0">
      <div class="video-container">
        <iframe src="https://www.youtube.com/embed/pKOgyTiR434" class="responsive-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
      </div>
    </b-modal>
  </header>
</template>
<script>
import classMenu from "../../views/course/class/menu";
import examMenu from "../../views/course/exam/menu";
import baseComponent from "../../components/baseComponent";
import { mapGetters, mapActions } from "vuex";
import { cart as cartStoreKeys, auth as authStoreKeys, headerType as headerTypeStoreKeys, specialCourses as specialCoursesStoreKeys } from "../../store/keys";
import { appConstants } from "../../common/constants";
import { blogs as blogsStoreKeys } from "../../store/keys";
import cryptojs from "../../plugins/crypto";

export default {
  extends: baseComponent,
  components: {
    classMenu: classMenu,
    examMenu: examMenu,
  },
  data() {
    return {
      activeMenu: null,
      isOpen: false,
      isScroll: false,
      visible: false,
      baseUrl: process.env.VUE_APP_URL,
    };
  },
  mounted() {
    const script = document.createElement("script");
    script.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js");
    document.head.appendChild(script);
    this.getSpecialCourses();
    this.addDropdownClassToLi();

    // Toggle menu function
    document.querySelector(".toggle-btn").addEventListener("click", this.toggleMenu);

    // Remove classes when any .sub-menu li a is clicked
    document.querySelectorAll(".sub-menu li a").forEach((link) => {
      link.addEventListener("click", this.closeMenu);
    });
    this.$nextTick(() => {
      const submenus = this.$el.querySelectorAll(".sub-menu");

      submenus.forEach((submenu) => {
        submenu.addEventListener("click", (event) => {
          const isLink = event.target.closest("a");

          if (isLink) {
            this.activeMenu = null; // Hide all submenus
          }
        });
      });
    });
  },
  beforeDestroy() {
    // Remove event listeners when component is destroyed
    document.querySelector(".toggle-btn").removeEventListener("click", this.toggleMenu);
    document.querySelectorAll(".sub-menu li a").forEach((link) => {
      link.removeEventListener("click", this.closeMenu);
    });
  },
  async serverPrefetch() {
    return this.getSpecialCourses();
  },
  computed: {
    ...mapGetters(cartStoreKeys.namespace, cartStoreKeys.getters),
    ...mapGetters(authStoreKeys.namespace, authStoreKeys.getters),
    ...mapGetters(headerTypeStoreKeys.namespace, headerTypeStoreKeys.getters),
    ...mapGetters(specialCoursesStoreKeys.namespace, specialCoursesStoreKeys.getters),
    ...mapGetters(blogsStoreKeys.namespace, blogsStoreKeys.getters),
  },
  props: ["scrolled"],
  methods: {
    ...mapActions(blogsStoreKeys.namespace, blogsStoreKeys.actions),
    ...mapActions(specialCoursesStoreKeys.namespace, specialCoursesStoreKeys.actions),
    generateEncryptedId(id) {
      return cryptojs.UTF.encrypt(id);
    },

    onMouseEnter(menuName) {
      if (window.innerWidth > 991) {
        this.activeMenu = menuName;
      }
    },
    onMouseLeave() {
      if (window.innerWidth > 991) {
        this.activeMenu = null;
      }
    },

    toggleMenu() {
      const toggleBtn = document.querySelector(".toggle-btn");
      const lowerHeader = document.querySelector(".lowerheader");

      toggleBtn.classList.toggle("active");
      lowerHeader.classList.toggle("activeMenu");

      // Toggle body overflow
      document.body.classList.toggle("overflow-hidden");
    },

    closeMenu() {
      document.querySelector(".toggle-btn").classList.remove("active");
      document.querySelector(".lowerheader").classList.remove("activeMenu");

      // Remove body overflow restriction
      document.body.classList.remove("overflow-hidden");
    },

    gotoPortal() {
      return;
      return `${process.env.VUE_APP_PORTAL_URL}/dashboard`;
    },

    openMenu() {
      this.isOpen = !this.isOpen;
      this.isOpen ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
    },

    hideScroll() {
      this.isScroll = !this.isScroll;
      this.isScroll ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
    },

    startScroll() {
      this.isScroll = false;
      this.isScroll ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
    },

    onOver(dropdownValue) {
      let customRef = this.$refs[dropdownValue];
      customRef.visible = true;
    },

    onLeave(dropdownValue) {
      let customRef = this.$refs[dropdownValue];
      customRef.visible = false;
    },

    getSpecialCourses(pagingMode) {
      return this.get_SpecialCourses({
        data: {
          CourseListFilter: 2,
          ProgramCategoryId: appConstants.enums.programCategory.All,
          ApplyDefaultTagFilter: false,
          PageNumber: 1,
          PageSize: 12,
        },
        config: {
          loader: {
            show: true,
            id: "examCoursesLoader",
          },
        },
        pagingMode: pagingMode,
      })
        .then((response) => {})
        .catch((ex) => {
          // this.$alertError(ex.message);
          console.log(ex.message);
        });
    },

    openPopup() {
      Calendly.initPopupWidget({ url: "https://calendly.com/kipsvirtual/ask-an-expert" });
      return false;
    },

    addDropdownClassToLi() {
      const listItems = document.querySelectorAll(".botnav li");

      listItems.forEach((li) => {
        if (li.querySelector("ul")) {
          li.classList.add("has_dropdown");

          li.addEventListener("click", function (event) {
            event.stopPropagation();
            const isActive = this.classList.contains("active");

            document.querySelectorAll(".has_dropdown.active").forEach((activeLi) => {
              activeLi.classList.remove("active");
            });

            if (!isActive) {
              this.classList.add("active");
            }
          });
        }
      });
    },
    openBookDemoPopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsonlineschool/book-a-demo",
      });
      return false;
    },
    openExpertAdvicePopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsonlineschool/ask-a-question",
      });
      return false;
    },
    showVideoPopup() {
      this.$bvModal.show("introductoryVideoModal");
    },
  },
};
</script>

<style scoped>
:v-deep #introductoryVideoModal .modal-content {
  background-color: black;
}

::v-deep #introductoryVideoModal .modal-body {
  padding: 0 !important;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Add media query for larger screens */
@media (min-width: 992px) {
  ::v-deep #introductoryVideoModal .modal-content {
    background-color: black;
  }

  .video-container {
    width: 152%;
    height: 80vh;
    /* This will take 80% of viewport height */
  }

  .responsive-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
